var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8,10.3c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0C1.2,8.6,1,7.8,0.7,6.3C0.7,5.7,1.1,5.2,1.6,5.1 C2.1,5.1,2.7,5.4,2.7,6c0,0.3,0.1,0.6,0.1,0.9C4.8,4,8.3,1.6,12,1.6c2.2,0,4.2,0.7,6,1.9c1.8,1.3,3.1,3,3.8,5 C22,9,21.7,9.6,21.2,9.8c-0.5,0.2-1.1-0.1-1.3-0.6c-0.6-1.6-1.6-3.1-3.1-4.1S13.7,3.6,12,3.6c-3.1,0-6.1,2.2-7.6,4.7 c0.4-0.1,0.9-0.3,1.4-0.4C6.3,7.7,6.9,8,7.1,8.5C7.2,9,7,9.6,6.4,9.8c-1.4,0.5-2.3,0.7-3.7,0.9c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.4-0.1c0,0,0,0,0,0c0,0,0,0,0,0C2.1,10.5,2,10.5,1.8,10.3C1.9,10.4,1.9,10.3,1.8,10.3z M23.5,17.6 c-0.3-1.5-0.6-2.3-1.2-3.6c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-1.4,0.3-2.2,0.6-3.7,1.2 c-0.5,0.2-0.7,0.8-0.5,1.3c0.2,0.5,0.8,0.7,1.3,0.5c0.4-0.2,0.8-0.3,1.2-0.5c-0.6,1-1.4,1.9-2.4,2.6c-1.5,1.1-3.3,1.8-5.2,1.9 c-1.7,0-3.4-0.5-4.8-1.5c-1.4-1-2.5-2.4-3.1-4c-0.2-0.5-0.8-0.8-1.3-0.6C2.3,14.5,2,15,2.2,15.6c0.7,2,2.1,3.7,3.8,5 c1.8,1.2,3.8,1.9,6,1.9c0,0,0,0,0,0c2.3-0.1,4.5-0.9,6.3-2.3c1.2-0.9,2.1-2,2.9-3.2c0.1,0.3,0.2,0.7,0.3,1.1c0.1,0.5,0.5,0.8,1,0.8 c0.1,0,0.1,0,0.2,0C23.3,18.7,23.6,18.2,23.5,17.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/resend-icon.3ead4536d3a58284f6d13eabb5e7f96f.svg";
export { ForwardRef as ReactComponent };